"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fields = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var FormContext_1 = tslib_1.__importDefault(require("./FormContext"));
;
/** @deprecated @pinto/react-form is not needed anymore, just use MobX */
var Fields = /** @class */ (function (_super) {
    tslib_1.__extends(Fields, _super);
    function Fields() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Fields.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this._unmount) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    Fields.prototype.render = function () {
        var _a = this.props, names = _a.names, Klass = _a.component, props = tslib_1.__rest(_a, ["names", "component"]);
        if (!this.context.registerField) {
            throw new Error("<Fields names={" + JSON.stringify(names) + "} /> used outside of a <Form />");
        }
        this._unmount = this.context.registerField(this.props.names, this);
        return react_1.default.createElement(Klass, tslib_1.__assign({}, props, this.context.getFieldsProps(this), { names: names }));
    };
    Fields.contextType = FormContext_1.default;
    Fields.propTypes = {
        names: prop_types_1.default.oneOfType([
            prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired,
            prop_types_1.default.objectOf(prop_types_1.default.string).isRequired,
        ]).isRequired,
        component: prop_types_1.default.func.isRequired,
    };
    return Fields;
}(react_1.default.PureComponent));
exports.Fields = Fields;
exports.default = Fields;
//# sourceMappingURL=Fields.js.map